import { createStyles, keyframes } from "@mantine/core"

export const pulseShrink = keyframes({
    "0": { transform: "scale(1)" },
    "50%": { transform: "scale(0.4)" },
    "100%": { transform: "scale(1)" },
})

export const pulseGrow = keyframes({
    "0": { transform: "scale(1)" },
    "50%": { transform: "scale(1.8)" },
    "100%": { transform: "scale(1)" },
})

export const useStyles = createStyles((theme) => ({
    topBarIcon: {
        color: "white",
    },

    chatIcon: {
        position: "absolute",
        width: "1.25em",
        left: "0.625em",
        height: "1em",
        top: "0.75em",
    },

    bigStarIcon: {
        position: "absolute",
        top: "0.55em",
        left: "1.45em",
        width: "0.5em",
        height: "0.5em",
        animation: `${pulseShrink} 1.5s ease-in-out infinite`,
        "@media (prefers-reduced-motion)": {
            animation: "none",
        },
    },

    smallStarIcon: {
        position: "absolute",
        top: "1em",
        left: "1.2em",
        width: "0.25em",
        height: "0.25em",
        animation: `${pulseGrow} 1.5s ease-in-out infinite`,
        "@media (prefers-reduced-motion)": {
            animation: "none",
        },
    },
}))
